import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuthUserService } from '../../auth/auth-user.service';

@Component({
    selector: 'app-logout-countdown',
    template: `
    <div *ngIf="remainingTime"
         class="fixed-top h-100 w-100 d-flex justify-content-center align-items-center countdown-overlay">
      <div class="p-5 text-center h3 countdown bg-light border border-medium rounded-20px">
        <span i18n>Logout </span> <span>{{remainingTime}}</span>
      </div>
    </div>
  `,
    styles: [`
    .countdown-overlay {
      z-index: 999999;
      background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.5), rgba(255, 255, 255, 0.8))
    }
  `],
    standalone: false
})

export class LogoutCountdownComponent implements OnInit {
  remainingTime: string | null = null;

  constructor(private readonly authService: AuthUserService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.authService.autoLogoutTimer.remainingTime.subscribe(remainingTime => {
      this.remainingTime = remainingTime && remainingTime.toFormat('mm:ss');
      // INFO: rendering in android webview not updates UI for every value change,
      //  so we need to trigger change detection for current component manually
      this.changeDetectorRef.detectChanges();
    });
  }
}
